<template>
  <div>
    <div>
      <h2>
        Téléchargez le Livre Blanc
        <span>des Clés de la Fidélisation Clients</span>
      </h2>
      <el-form :model="form" :rules="rules" ref="form" id="the-tele-form">
        <div class="row row-spaced">
          <div class="col-sm-6">
            <div class="one-form-section">
              <el-radio v-model="form.civilite" label="Madame">Madame</el-radio>
              <el-radio v-model="form.civilite" label="Monsieur">Monsieur</el-radio>
            </div>
            <el-form-item class="one-form-section" prop="nom">
              <el-input v-model="form.nom" placeholder="Nom*" />
            </el-form-item>
            <el-form-item class="one-form-section" prop="prenom">
              <el-input v-model="form.prenom" placeholder="Prénom*" />
            </el-form-item>
            <el-form-item id="entreprise" class="one-form-section" prop="entreprise">
              <el-input v-model="form.entreprise" placeholder="Entreprise" />
            </el-form-item>
          </div>
          <div class="col-sm-6">
            <div class="one-form-section client-agricole">
              <label>
                Êtes-vous client(e) du Crédit Agricole ? *
              </label>
              <br />
              <el-radio v-model="form.client" label="Oui">Oui</el-radio>
              <el-radio v-model="form.client" label="Non">Non</el-radio>
            </div>
            <el-form-item v-if="form.client === 'Oui'" class="one-form-section" prop="caisse">
              <el-select v-model="form.caisse" placeholder="Choisissez une caisse régionale*">
                <el-option
                  v-for="caisse in caisses"
                  :key="caisse"
                  :label="caisse"
                  :value="caisse"
                />
              </el-select>
            </el-form-item>
            <div class="one-form-section">
              <div class="row row-spaced">
                <el-form-item class="col-sm-6" prop="codePostal">
                  <el-input v-model="form.codePostal" placeholder="Code postal*" />
                </el-form-item>
              </div>
            </div>
          </div>
        </div>
        <div class="row row-spaced">
          <div class="col-sm-12">
            <h4>Mes préférences pour être contacté(e)</h4>
            <p v-if="error" class="error">Merci de renseigner au moins une des informations ci-dessous.</p>
          </div>
          <div class="col-sm-5">
            <el-form-item prop="telephone">
              <el-input v-model="form.telephone" placeholder="Téléphone" />
            </el-form-item>
          </div>
          <div class="col-sm-1 text-center text-or">OU</div>
          <div class="col-sm-5">
            <el-form-item class="one-form-section" prop="email">
              <el-input v-model="form.email" placeholder="Adresse e-mail" />
            </el-form-item>
          </div>
        </div>

        <el-checkbox v-model="checked">
          <strong>En cochant cette case, j’accepte que le groupe Crédit Agricole ou
          son sous-traitant me contacte par e-mail afin de recevoir des
            informations sur la solution clef en main Up2pay Fidélité.</strong>
        </el-checkbox>

        <div class="text-center">
          <p>
            <a
              href="#"
              target="_blank"
              data-trackingclass="landing-page-clic-bouton"
              data-trackinginfo="landing-page-CAPS-up2payfid-telecharger"
              class="the-button"
              @click.prevent="save"
            >
              télécharger le livre blanc
            </a>
          </p>
          <p>
            *Champs obligatoires.
          </p>
          <p>
            L'ensemble des informations du formulaire dont les champs sont suivis d’un astérisque sont obligatoires pour
            le traitement de votre demande. Elles sont recueillies par Crédit Agricole Payment Services responsable du
            traitement afin de vous recontacter à l'issue de votre demande d’informations. Conformément à la
            règlementation relative aux données personnelles et à la politique de protection des données , vous
            bénéficiez d’un droit d’accès, de rectification, d’effacement, d’opposition, de limitation, à la portabilité
            pour les données vous concernant que vous pouvez exercer en adressant un mail à
            <a href="mailto:dpo.caps@ca-ps.com">dpo.caps@ca-ps.com</a>.
          </p>
          <p>
            Pour plus d'informations concernant le traitement de vos données, nous vous invitons à consulter
            la politique de protection des données du site
            <a href="https://www.ca-moncommerce.com/politique-de-protection-des-donnees/" target="_top">https://www.ca-moncommerce.com/</a>.
          </p>
          <p>
            Ce site est protégé par reCAPTCHA. La politique de confidentialité ainsi que les conditions d'utilisation de Google s'appliquent.
          </p>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import validator from 'validator'
import axios from 'axios'

export default {
  data () {
    const email = (rule, value, callback) => {
      if (value && !validator.isEmail(value)) {
        callback(new Error('Adresse email est invalide'))
      } else {
        callback()
      }
    }
    const caisse = (rule, value, callback) => {
      if (!value || this.client === 'Oui') {
        callback(new Error('Saisissez une caisse régionale'))
      } else {
        callback()
      }
    }
    return {
      api: axios.create(),
      pdf: '/static/livre-blanc.pdf',
      checked: false,
      error: false,
      form: {
        civilite: null,
        nom: null,
        prenom: null,
        codePostal: null,
        telephone: null,
        entreprise: null,
        email: null,
        caisse: null,
        client: 'Oui'
      },
      rules: {
        codePostal: [
          {required: true, message: 'Saisissez un code postal', trigger: 'blur'},
          {min: 5, max: 5, message: 'Code postal invalide', trigger: 'blur'}
        ],
        telephone: [
          {required: false, min: 10, message: 'Téléphone invalide', trigger: 'blur'}
        ],
        nom: [
          {required: true, message: 'Saisissez un nom', trigger: 'blur'}
        ],
        prenom: [
          {required: true, message: 'Saisissez un prénom', trigger: 'blur'}
        ],
        email: [
          {required: false, validator: email, trigger: 'blur'}
        ],
        caisse: [
          {required: true, validator: caisse, trigger: 'blur'}
        ]
      },
      caisses: [
        'Alpes Provence',
        'Alsace Vosges',
        'Anjou et Maine',
        'Aquitaine',
        'Brie Picardie',
        'Atlantique Vendée',
        'Centre-est',
        'Centre France',
        'Centre Loire',
        'Centre Ouest',
        'Champagne-Bourgogne',
        'Charente-Maritime Deux-Sèvres',
        'Charente-Périgord',
        'Corse',
        'Côtes d\'Armor',
        'Finistère',
        'Franche-Comté',
        'Guadeloupe',
        'Île-de-France',
        'Ille-et-Vilaine',
        'Languedoc',
        'Loire Haute-Loire',
        'Lorraine',
        'Martinique et Guyane',
        'Morbihan',
        'Nord de France',
        'Nord Est',
        'Nord Midi Pyrénées',
        'Normandie',
        'Normandie-Seine',
        'Provence Côte d\'Azur',
        'Pyrénées Gascogne',
        'La Réunion',
        'Savoie',
        'Sud Méditerranée',
        'Sud Rhône Alpes',
        'Toulouse 31',
        'Touraine et Poitou',
        'Val de France'
      ]
    }
  },
  methods: {
    save () {
      this.error = !this.form.telephone && !this.form.email
      this.$refs.form.validate((valid) => {
        if (valid && !this.error) {
          if (this.pdf && this.pdf.length > 1) {
            this.$nextTick(() => window.open(this.pdf, '_blank'))
          }

          if (this.checked) {
            this.api.post('/save', this.form).then(() => {
              this.checked = false
              this.form = {
                civilite: null,
                nom: null,
                prenom: null,
                codePostal: null,
                telephone: null,
                entreprise: null,
                email: null,
                caisse: null,
                client: 'Oui'
              }
            })
          }
        }
      })
      return false
    }
  }
}
</script>

<style lang="scss" scoped>
  .the-button {
    margin-top: 25px;
    color: white !important;
  }
  .text-or {
    line-height: 50px;
  }
  .el-select {
    width: 100%;
  }
  .el-form-item {
    margin-bottom: 20px !important;
  }
  .error {
    color: red;
  }
  /*
  #entreprise {
    margin-top: -2px !important;

  }
   */
  h4 {
    font-size: 18px;
  }

  @media screen and (min-width: 992px) {
    .client-agricole {
      padding-top: 44px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Form.vue